var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Search",
    fill: "#9B9B9B",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.83,15.218 C12.1432938,15.218 15.65,11.8866291 15.65,7.764 C15.65,3.6413709 12.1432938,0.31 7.83,0.31 C3.51670621,0.31 0.01,3.6413709 0.01,7.764 C0.01,11.8866291 3.51670621,15.218 7.83,15.218 Z M7.83,14.218 C4.05784505,14.218 1.01,11.3225472 1.01,7.764 C1.01,4.2054528 4.05784505,1.31 7.83,1.31 C11.6021549,1.31 14.65,4.2054528 14.65,7.764 C14.65,11.3225472 11.6021549,14.218 7.83,14.218 Z",
    id: "Oval"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "12.4656253 13.3324997 18.8256253 19.3744997 19.5143747 18.6495003 13.1543747 12.6075003"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.5bf858c24104798ad9d1bdded0adf7ea.svg";
export { ForwardRef as ReactComponent };